import { render } from "./ItemFilter.vue?vue&type=template&id=0b5205f9&scoped=true"
import script from "./ItemFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilter.vue?vue&type=script&lang=js"

import "./ItemFilter.vue?vue&type=style&index=0&id=0b5205f9&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5205f9"]])

export default __exports__